import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from "lodash";
import { fetchProducts } from '../../actions/pos';
import Spinner from '../shared/spinner';
import defaultImage from '../../assets/images/default.jpg';

import '../../assets/styles/pos.css';

class SelectProduct extends Component {

    componentDidMount() {
        if(this.props.category) {
            this.props.fetchProducts({category_id: this.props.category.id});
        } else {
            this.props.fetchProducts({activity_id: this.props.activity.id});
        }
    }

    addToCart(product) {
        this.props.callbackToUpdateComponent({showCart: true, cart: this.updatedCart(product) })
    }

    setCategory() {
        this.props.callbackToUpdateComponent({ category: null })
    }

    updatedCart(product) {
        let alreadyInCart = _.find(this.props.cart, (cartProduct) => cartProduct.id === product.id);
        let updatedCart = this.props.cart ? _.clone(this.props.cart, true) : [];
        if(alreadyInCart) {
            _.remove(updatedCart, (cartProduct) => cartProduct.id === product.id);
            alreadyInCart.quantity = alreadyInCart.quantity + 1;
            alreadyInCart.price = product.price * alreadyInCart.quantity;
            alreadyInCart.tax = product.tax * alreadyInCart.quantity;
            updatedCart.push(alreadyInCart);
        } else {
            updatedCart.push({id: product.id, price: product.price, quantity: 1, description: product.description, tax: product.tax});
        }
        return updatedCart
    }

    renderProductImage(product) {
        if(product.images.length > 0) {
            return <img className='product-image' src={product.images[0]} alt='no-preview'/>;
        }
        return <img className='product-image' src={defaultImage} alt='' />;
    }

    renderProducts(products) {
        return _.map(products, (product) => {
            return (
                <div className='col-lg-3 col-md-3 col-xs-6' key={product.id}>
                    <div className="thumbnail">
                        {this.renderProductImage(product)}
                        <div className="caption">
                            <h4 className='thumbnail-title'>{product.description}</h4>
                            <div className='text-muted'>{this.props.currency}{product.price}</div>
                            <p>
                                <button onClick={this.addToCart.bind(this, product)} className="btn btn-sm btn-primary">Add To Cart</button>
                            </p>
                        </div>
                    </div>
                </div>
            )
        })
    }

    render () {
        const {products} = this.props;
        if (!products) {
            return <Spinner/>;
        } else {
            return (
                <div className='row-eq-height'>
                    <div className="col-xs-12 col-md-12 col-lg-12 pt-15 pb-15 border-bottom">
                        {this.props.appointment && <h5 className='text-danger'>You need to purchase a package before we can confirm your appointment.</h5>}
                        <div>
                            <div className='col-xs-12 col-md-12 col-lg-12 text-right mb-15'>
                                {this.props.cart && <button className='btn btn-primary' onClick={this.props.checkout}>Checkout</button>} &nbsp;
                                <button className='btn btn-primary' onClick={this.props.toggleCart}>View Cart</button> &nbsp;
                                {this.props.activity ? '' : <button className='btn btn-secondary' onClick={this.setCategory.bind(this)}>Go Back</button>}
                            </div>
                        </div>
                        <div>
                            {this.renderProducts(products)}
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { products } = state;
    return { products };
}

export default connect(mapStateToProps, { fetchProducts })(SelectProduct);



// WEBPACK FOOTER //
// ./src/components/pos/selectProduct.js